import React from 'react'

const XlsxIcon = () => {
  return (
    <svg width="32" height="39" viewBox="0 0 43 40" fill="none">
      <path
        style={{ fill: '#e2e5e7' }}
        d="M12.75 0c-1.753 0 -3.188 1.434 -3.188 3.188v44.625c0 1.753 1.434 3.188 3.188 3.188h31.875c1.753 0 3.188 -1.434 3.188 -3.188V12.75L35.063 0z"
      />
      <path
        style={{ fill: '#b0b7bd' }}
        d="M38.25 12.75h9.563L35.063 0v9.563c0 1.753 1.434 3.188 3.188 3.188"
      />
      <path
        style={{ fill: '#cad1d8' }}
        d="m47.813 22.313 -9.563 -9.563h9.563z"
      />
      <path
        style={{ fill: '#84bd5a' }}
        d="M41.438 41.438c0 0.877 -0.717 1.594 -1.594 1.594H4.781c-0.877 0 -1.594 -0.717 -1.594 -1.594V25.5c0 -0.877 0.717 -1.594 1.594 -1.594h35.063c0.877 0 1.594 0.717 1.594 1.594z"
      />
      <path
        style={{ fill: '#fff' }}
        d="m14.377 32.492 2.217 -2.778c0.663 -0.867 1.951 0.241 1.224 1.069 -0.763 0.905 -1.567 1.887 -2.332 2.893l2.599 3.237c0.701 0.956 -0.7 1.873 -1.388 0.929l-2.346 -3.007 -2.306 3.073c-0.65 0.929 -2.091 -0.115 -1.364 -0.982l2.561 -3.25c-0.803 -1.007 -1.581 -1.987 -2.357 -2.893 -0.802 -0.956 0.689 -1.936 1.275 -1.042zm5.282 -2.295c0 -0.421 0.357 -0.778 0.803 -0.778 0.408 0 0.752 0.359 0.752 0.778v6.385h3.466c1.248 0 1.275 1.669 0 1.669H20.464c-0.446 0 -0.803 -0.317 -0.803 -0.776v-7.277zm7.438 1.147c0.293 -2.474 4.026 -2.918 5.785 -1.567 0.867 0.7 -0.051 1.809 -0.816 1.248 -0.944 -0.598 -3.084 -0.878 -3.352 0.445 -0.344 2.091 5.199 0.894 5.11 4.284 -0.089 3.237 -4.778 3.312 -6.538 1.86 -0.422 -0.344 -0.408 -0.904 -0.178 -1.25 0.331 -0.33 0.7 -0.445 1.135 -0.088 1.044 0.712 3.734 1.248 3.924 -0.563 -0.164 -1.884 -5.465 -0.751 -5.07 -4.37"
      />
      <path
        style={{ fill: '#cad1d8' }}
        d="M39.844 43.031H9.563v1.594h30.281c0.877 0 1.594 -0.717 1.594 -1.594v-1.594c0 0.877 -0.717 1.594 -1.594 1.594"
      />
    </svg>
  )
}

export default XlsxIcon
